// extracted by mini-css-extract-plugin
export default {"leftNavigation":"apiPortal_leftNavigation__XaBgS","selected":"apiPortal_selected__lN3Vy"};